const template = require('./emptyDetails.template');
require('./emptyDetails.styles');

/**
 * @ngdoc directive
 * @name sharebase-app.directive:sbaEmptyDetails
 * @module sharebase-app
 * @restrict E
 * @description
 *
 * `sbaEmptyDetails` displays empty details UI
 *
 * @usage
 *
 * <sba-empty-details /> 
 */
export function EmptyDetailsDirective() {
	return {
		restrict: 'E',
		controllerAs: 'emptyDetailsCtrl',
		controller: angular.noop,
		template,
		bindToController: true,
		scope: {},
		link: function (scope, element, attrs) {}
	};
}


// WEBPACK FOOTER //
// ./src/sharebase-app/components/emptyDetails/emptyDetails.ts